// extracted by mini-css-extract-plugin
export var emailBlockLink = "_jb-0";